<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Amount" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.amount ? (Math.round(activeBulkPayment.amount * 100) / 100).toFixed(2) + "€" : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Payer IBAN" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.payer_iban ? activeBulkPayment.payer_iban : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Payer name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.payer_name ? activeBulkPayment.payer_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Payment key" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.payment_key ? activeBulkPayment.payment_key : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Type" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeBulkPayment.payment_type
                        ? activeBulkPayment.payment_type.charAt(0).toUpperCase() + activeBulkPayment.payment_type.slice(1)
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-row v-if="activeBulkPayment && activeBulkPayment.deadline">
            <v-col class="col-item row-title" cols="3">{{ "Deadline" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.deadline ? activeBulkPayment.deadline : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeBulkPayment && activeBulkPayment.postback_sent_at">
            <v-col class="col-item row-title" cols="3">{{ "Postback sent at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.postback_sent_at ? tz(activeBulkPayment.postback_sent_at) : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3"/>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Partner payment reference" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.partner_payment_reference ? activeBulkPayment.partner_payment_reference : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.status ? activeBulkPayment.status : "-" }}
                <span
                    v-if="activeBulkPayment.status"
                    :style="{ 'background-color': getStatusColor(activeBulkPayment.status) }"
                    class="dot"
                ></span>
            </v-col>
        </v-row>
        <v-row v-if="activeBankName">
            <v-col class="col-item row-title" cols="3">{{ "Bank name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBankName ? activeBankName : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeBulkPayment.swift">
            <v-col class="col-item row-title" cols="3">{{ "Swift" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.swift ? activeBulkPayment.swift : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeBulkPayment && activeBulkPayment.platform">
            <v-col class="col-item row-title" cols="3">{{ "Platform" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeBulkPayment.platform
                        ? activeBulkPayment.platform.charAt(0).toUpperCase() + activeBulkPayment.platform.slice(1)
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3"/>
        <v-row v-if="user.role === 'admin'">
            <v-col class="col-item row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.company_name ? activeBulkPayment.company_name : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3"/>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Created at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.created_at ? tz(activeBulkPayment.created_at) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Last updated" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.updated_at ? tz(activeBulkPayment.updated_at) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Ext status checked at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.ext_status_checked_at ? tz(activeBulkPayment.ext_status_checked_at) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Ext status recieved at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeBulkPayment.ext_status_rcvd_at ? tz(activeBulkPayment.ext_status_rcvd_at) : "-" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "payment-info-tab",
    computed: {
        ...mapState(["user", "bank_names"]),
        ...mapState('bulkPaymentHistory', ['activeBulkPayment'])
    },
    data() {
        return {
            activeBankName: null
        };
    },
    async beforeUpdate() {
        this.activeBankName = null;
        if (this.activeBulkPayment) {
            for (let i = 0; i < this.bank_names.length; i++) {
                if (this.activeBulkPayment.swift === Object.values(this.bank_names)[i].swift) {
                    this.activeBankName = Object.values(this.bank_names)[i].name;
                    break;
                }
            }
        }
    },
    methods: {
        getStatusColor(status) {
            if (status === "finished") {
                return "#4CAF50";
            } else if (["failed", "cancelled"].includes(status)) {
                return "#FF0000";
            } else if (status === "waiting") {
                return "#999999";
            } else if (status === "expired") {
                return "#0066ff";
            } else if (status === "started") {
                return "#eec01f";
            } else if (status === "inactive") {
                return "#af00ac";
            } else if (status === "partial") {
                return "#c46600";
            } else {
                return "#999999";
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.dot {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    display: inline-block;
}
</style>
